import { CHANGE_USER_PAGE_NOTIFICATIONS_LOADING, SET_USER_PAGE_NOTIFICATIONS_NEW_COMMENTS, } from "../constants";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_USER_PAGE_NOTIFICATIONS_NEW_COMMENTS: {
            const newComments = action.payload;
            return Object.assign(Object.assign({}, state), { newComments });
        }
        case CHANGE_USER_PAGE_NOTIFICATIONS_LOADING: {
            const loading = action.payload;
            return Object.assign(Object.assign({}, state), { loading });
        }
        default:
            return state;
    }
};
export { reducer };
